/**
 * plugins/webfontloader.js
 *
 * webfontloader documentation: https://github.com/typekit/webfontloader
 */

export async function loadFonts () {
  const webFontLoader = await import(/* webpackChunkName: "webfontloader" */'webfontloader')

  webFontLoader.load({
    google: {
      families: [
        'Plus Jakarta Sans:400,500,600,700&display=swap',
        'Lora:400,400i,500,600,700&display=swap',
        'Outfit:500,600,700&display=swap',
      ],
    },
  })
}
